import { useCallback, useEffect, useState } from "react";

const KEY = "cpenz_theme";           // "auto" | "day" | "night"
const NIGHT_FROM = 20, NIGHT_TO = 7; // device local time

export const isNightHour = (d = new Date()) => { const h = d.getHours(); return h >= NIGHT_FROM || h < NIGHT_TO; };
const read = () => { try { return localStorage.getItem(KEY) || "auto"; } catch { return "auto"; } };

/** Day/night theme: "auto" follows the device clock (night 20:00–07:00) and paints the app as a negative (html.night). */
export function useTheme() {
  const [mode, setModeState] = useState(read);
  const [night, setNight] = useState(() => (read() === "night" ? true : read() === "day" ? false : isNightHour()));
  useEffect(() => {
    const apply = () => setNight(mode === "night" ? true : mode === "day" ? false : isNightHour());
    apply();
    const iv = setInterval(apply, 60000);
    return () => clearInterval(iv);
  }, [mode]);
  useEffect(() => { document.documentElement.classList.toggle("night", night); document.documentElement.dataset.theme = night ? "night" : "day"; }, [night]);
  useEffect(() => {
    const onStorage = (e) => { if (e.key === KEY) setModeState(read()); };
    const onCustom = () => setModeState(read());
    window.addEventListener("storage", onStorage); window.addEventListener("cpenz-theme", onCustom);
    return () => { window.removeEventListener("storage", onStorage); window.removeEventListener("cpenz-theme", onCustom); };
  }, []);
  const setMode = useCallback((m) => { try { localStorage.setItem(KEY, m); } catch {} setModeState(m); window.dispatchEvent(new Event("cpenz-theme")); }, []);
  const cycle = useCallback(() => setMode(mode === "auto" ? "night" : mode === "night" ? "day" : "auto"), [mode, setMode]);
  return { mode, night, setMode, cycle };
}
